import type { PolicyKey } from './structural-ids';

/**
 * Map a Unify role (plus client flag) to the canonical AccessPolicy key.
 * Unknown roles must not fall through to unifyAdmin.
 */
export function accessPolicyKeyForRole(role: string, isClient = false): PolicyKey {
  if (isClient || role === 'client') return 'patientSelf';
  switch (role) {
    case 'practice-assistant':
      return 'practiceAssistant';
    case 'supervisor':
      return 'supervisor';
    case 'practice-owner':
    case 'practice-admin':
      return 'practiceAdmin';
    case 'provider':
      return 'provider';
    case 'unify-admin':
      return 'unifyAdmin';
    case 'unify-assistant':
      return 'unifyAssistant';
    default:
      throw new Error(`Unknown role "${role}" has no AccessPolicy mapping`);
  }
}
